import { render } from "./ArticleLogo.vue?vue&type=template&id=4c1e9242&scoped=true"
import script from "./ArticleLogo.vue?vue&type=script&lang=js"
export * from "./ArticleLogo.vue?vue&type=script&lang=js"

import "./ArticleLogo.vue?vue&type=style&index=0&id=4c1e9242&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1e9242"]])

export default __exports__